import goodsImportOperateDetail from './goods_import_operate_detail.vue'

export default {
    name: 'goodsImportOperateDetail',
    path: 'goodsImportOperateDetail',
    component: goodsImportOperateDetail
}
